module.exports = __webpack_public_path__ + "img/entia-portafolio-transmision-distribucion-1.d3c0b07b.jpg";